import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { AssociateCompanyRequest, CompanyActivityNameResponse } from 'src/app/models/company.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { UserNitResponse } from 'src/app/models/user.model';
import { CompanyService } from 'src/app/services/company.service';
import { UserService } from 'src/app/services/user.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';

@Component({
  selector: 'app-modal-associate-company',
  templateUrl: './modal-associate-company.component.html',
  styleUrls: ['./modal-associate-company.component.scss']
})
export class ModalAssociateCompanyComponent implements OnInit {
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  @Output() close = new EventEmitter<any>();
  newCompany: AssociateCompanyRequest = new AssociateCompanyRequest();
  activities: CompanyActivityNameResponse[] = [];
  collectionActivities: { [key: number]: CompanyActivityNameResponse } = {};
  inputActivity = new InputAutocompleteModel(null, false, false, '', '', '', '', null, []);
  inputNit = new InputAutocompleteModel(null, false, false, '', '', '', '', null, []);
  timeout = null;
  loading = false;

  constructor(
    private toastService: ToastrService,
    private companyService: CompanyService,
    private userService: UserService,
    private authService: AuthenticationService
  ) {

  }

  ngOnInit(): void {
    this.getActivities();
  }


  getActivities() {
    this.companyService.getActivities().subscribe({
      next: (response: ResponseObject) => {
        this.activities = response.data;
        this.activities.forEach((ac) => {
          this.collectionActivities[ac.id] = ac;
        });
        this.inputActivity.filterElements = this.activities;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  writeNit() {
    clearTimeout(this.timeout);
    this.newCompany.companyNit = this.inputNit.value;
    this.inputNit.class = "typing";
    this.timeout = setTimeout(() => {
      this.userService.checkNIT(this.inputNit.value).subscribe({
        next: (response: ResponseObject) => {
          this.inputNit.class = "";
          this.inputNit.filterElements = response.data;
        },
        error: (error: HttpErrorResponse) => {
          this.inputNit.class = "";
          this.toastService.error(error.error.message);
        }
      })
    }, 500);
  }

  selectNit(nit: UserNitResponse) {
    this.newCompany.companyName = nit.name;
    this.inputNit.value = nit.nit;
  }

  write() {
    this.inputActivity.filterElements = this.activities.filter((activity) => {
      return activity.code == this.inputActivity.value || activity.name.toLowerCase().includes(this.inputActivity.value.toLowerCase())
        || activity.id + "" == this.inputActivity.value
    });

  }

  select(activitySelected) {
    if (this.newCompany.companyActivities.length > 2) {
      this.toastService.info("Solo puedes seleccionar un máximo de 3 actividades");
      return;
    }
    var find = this.newCompany.companyActivities.find((activity) => {
      return activity == activitySelected.id;
    })
    if (!find) {
      this.newCompany.companyActivities.push(activitySelected.id);
      this.inputActivity.value = "";
      this.inputActivity.filterElements = this.activities;
    } else {
      this.toastService.info("Ya se encuentra ingresada la actividad");
    }
  }

  saveAssociate() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.newCompany.userId = JSON.parse(this.authService.getCurrentUser()).id;
    this.userService.createAssociateCompany(this.newCompany).subscribe({
      next: (response: ResponseObject) => {
        this.loading = false;
        this.toastService.success("Se ha creado exitosamente la empresa");
        this.close.emit(response.data);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }
}
